import React, { useState } from "react";
import heroImg from "../../assets/images/Hero.png";
import { useNavigate } from "react-router-dom";



const Careers = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const navigate=useNavigate()

  const faqs = [
    {
      question: "Physical Design Engineer",
      about:
        "As a Physical Design Engineer, you will work on floorplanning, placement, clock tree synthesis (CTS), routing, and signoff to deliver high-performance and low-power silicon designs.",
      requirements: [
        "Hands-on experience with floorplanning, placement, CTS, and routing",
        "Good knowledge of timing closure and power optimization",
        "Experience with tools like ICC2, Innovus",
      ],
      qualification:
        "Bachelor’s or Master’s degree in Electronics / VLSI / related field.",
      salary: "₹6,00,000 - ₹12,00,000 per annum (based on experience)",
      location: "Bangalore / Hyderabad",
      applynow: "APPLY NOW",
    },
    {
      question: "Design Verification Engineer",
      about:
        "You will be responsible for verifying RTL designs using advanced verification methodologies to ensure functional correctness of complex SoCs.",
      requirements: [
        "Strong knowledge of SystemVerilog and UVM",
        "Experience in writing testbenches and assertions",
        "Understanding of RTL design and verification flows",
      ],
      qualification:
        "Bachelor’s or Master’s degree in Electronics / Embedded Systems.",
      salary: "₹7,00,000 - ₹14,00,000 per annum",
      location: "Bangalore / Noida",
      applynow: "APPLY NOW",
    },
    {
      question: "DFT Engineer",
      about:
        "As a DFT Engineer, you will implement scan, ATPG, and test methodologies to improve chip testability and fault coverage.",
      requirements: [
        "Knowledge of scan insertion, ATPG, and fault models",
        "Experience with tools like Tessent or DFT Compiler",
        "Understanding of manufacturing test flows",
      ],
      qualification:
        "Bachelor’s or Master’s degree in VLSI / Electronics.",
      salary: "₹7,00,000 - ₹13,00,000 per annum",
      location: "Bangalore / Pune",
      applynow: "APPLY NOW",
    },
    {
      question: "EM/IR/PDN Engineer",
      about:
        "You will focus on chip reliability by analyzing IR drop, electromigration, and designing robust power delivery networks.",
      requirements: [
        "Experience with IR drop and EM analysis",
        "Knowledge of PDN planning and power integrity",
        "Hands-on with tools like Voltus or RedHawk",
      ],
      qualification:
        "Bachelor’s or Master’s degree in VLSI / Electronics Engineering.",
      salary: "₹8,00,000 - ₹15,00,000 per annum",
      location: "Bangalore / Hyderabad",
      applynow: "APPLY NOW",
    },
    {
      question: "Analog Layout Engineer",
      about:
        "As an Analog Layout Engineer, you will create high-quality layouts for analog and mixed-signal circuits while ensuring performance, matching, and reliability.",
      requirements: [
        "Strong understanding of analog layout techniques",
        "Experience with matching, shielding, and guard rings",
        "Hands-on experience with Cadence Virtuoso",
      ],
      qualification:
        "Bachelor’s or Master’s degree in Electronics / VLSI.",
      salary: "₹6,50,000 - ₹12,00,000 per annum",
      location: "Bangalore / Chennai",
      applynow: "APPLY NOW",
    },
    {
      question: "STA/Synthesis Engineer",
      about:
        "You will be responsible for RTL synthesis, static timing analysis, and timing closure across multiple operating corners.",
      requirements: [
        "Strong knowledge of STA concepts and timing constraints",
        "Experience with PrimeTime and Design Compiler",
        "Understanding of low-power and multi-corner analysis",
      ],
      qualification:
        "Bachelor’s or Master’s degree in Electronics / VLSI Engineering.",
      salary: "₹7,00,000 - ₹14,00,000 per annum",
      location: "Bangalore / Hyderabad",
      applynow: "APPLY NOW",
    },
  ];
  

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleApplyNow = (jobTitle: string) => {
    navigate('/apply')
  };

  return (
    <div>
      <img src={heroImg} className="w-100" alt="hero" />

      <div className="container my-5">

        <div className="row">
          <div className="col-md-9 mt-5">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="faq-item border rounded p-3 mb-3 shadow-sm"
              >
                <div
                  className="faq-question d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleFAQ(index)}
                >
                  <h5 className="mb-0">{faq.question}</h5>
                  <span className="fs-4">
                    {activeIndex === index ? "−" : "+"}
                  </span>
                </div>

                {activeIndex === index && (
                  <div className="faq-answer mt-3">
                    <p>
                      <strong>About the Job:</strong> {faq.about}
                    </p>
                    <p>
                      <strong>Job Requirements:</strong>
                    </p>
                    <ul>
                      {faq.requirements.map((req, i) => (
                        <li key={i}>{req}</li>
                      ))}
                    </ul>
                    <p>
                      <strong>Qualification:</strong> {faq.qualification}
                    </p>
                    <div className="applynow">
                    <button
                      className="btn btn-success"
                      onClick={() => handleApplyNow(faq.question)}
                    >
                      {faq.applynow}
                    </button>
                      </div>
                    
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="col-md-3">
            <div className="hiring-sideb">
              <p className="hiring-help">Need Help?</p>
              <p className="hiring-back">
                We will get back to you shortly, or just call us now.
              </p>
              <span className="hiring-back mt-0">chipnestsemiconductor@gmail.com</span>
              <br />
              <span className="hiring-back">+91 9483484071</span>
            </div>
          </div>
        </div>
      </div>
   
    </div>
  );
};

export default Careers;